import { render, staticRenderFns } from "./favorite-props.vue?vue&type=template&id=593ec836&scoped=true"
import script from "./favorite-props.vue?vue&type=script&lang=js"
export * from "./favorite-props.vue?vue&type=script&lang=js"
import style0 from "./favorite-props.vue?vue&type=style&index=0&id=593ec836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ec836",
  null
  
)

export default component.exports